module.exports = __webpack_public_path__ + "cement/img/图像 297@2x.56079b0f.png";